import httpService from '@/modules/common/services/httpService';

const taxSettingsRoute = '/business/payments/v1/taxes';

const taxList = (page, perPage) => httpService.get(taxSettingsRoute, { page, per_page: perPage, new_api: true });

export default {
  taxList,
};
